"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { useModalInquiryContext } from "@/context/ModalInquiryContext";

const IMAGE_SRC =
	"/image/new-version/ValueAddedSolutions/On-Demand-Manufacturing/js-precision-on-demand-manufacturing.jpg";

const GlobeMark = () => (
	<svg
		className="h-14 w-14 text-themePrimary400 sm:h-16 sm:w-16 md:h-[72px] md:w-[72px] lg:h-20 lg:w-20"
		viewBox="0 0 48 48"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<circle cx="24" cy="24" r="20" />
		<ellipse cx="24" cy="24" rx="20" ry="8" />
		<ellipse cx="24" cy="24" rx="8" ry="20" />
	</svg>
);

export default function OnDemandManufacturingIntro() {
	const t = useTranslations("new-on-demand-manufacturing");
	const { openModalInquiry } = useModalInquiryContext();

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="relative mb-8 flex min-h-[72px] items-center sm:mb-10 sm:min-h-[80px] md:mb-12 md:min-h-[88px]">
					<h2 className="max-w-[680px] text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("introTitle")}
					</h2>
					<div className="absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 items-center justify-center sm:flex">
						<GlobeMark />
					</div>
				</div>

				<div className="grid items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-16">
					<div className="relative aspect-[6/5] w-full border border-gray-200 bg-white">
						<Image
							src={IMAGE_SRC}
							alt={t("introImageAlt")}
							fill
							className="object-contain p-4 sm:p-6"
							sizes="(max-width: 1024px) 100vw, 50vw"
							priority={false}
						/>
					</div>

					<div>
						<p className="mb-6 text-sm leading-relaxed text-black md:mb-8 md:text-base">{t("introDesc")}</p>
						<button
							type="button"
							onClick={openModalInquiry}
							className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] md:px-8 md:py-3.5 md:text-base"
						>
							{t("introGetInstantQuote")}
						</button>
					</div>
				</div>
			</div>
		</section>
	);
}
